var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMyList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 18,
  x: 3,
  y: 3,
  stroke: "#B2B2B2",
  strokeWidth: 1.5,
  rx: 1.714
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 18,
  x: 10.79,
  y: 4.213,
  stroke: "#B2B2B2",
  strokeWidth: 1.5,
  rx: 1.714,
  transform: "rotate(-15 10.79 4.213)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#B2B2B2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M5 17h3M16.345 17.218l2.898-.777"
})));
export default SvgMyList;